export const basicColor = {
  primary: '#1976D2',
  secondary: '#FF9800',
  background: '#ECEFF1',
  text: '#37474F',
  success: '#43A047',
  active: '#00C408', // 適用中
  inactive: '#E5E8F0', // 適用終了・適用待ち
  error: '#C62828',
  danger: '#E54040',
  disabled: '#CFD8DC',
} as const

export const extendedColor = {
  shallowBlue: '#64B5F6',
  deepBlue: '#63A4FF',
  skyBlue: '#2d9cdb',
  accentBlue: '#005492',
  accentBlueHover: '#0066B3',
  iconBlue: '#0068B3',
  deepRed: '#D63838',
  darkGray: '#767676',
  shallowGray: '#CCC',
  mediumGray: '#B0BEC5',
  lightGray: '#E0E0E0',
  white: '#FFFFFF',
  black: '#000000',
  transparent: 'rgba(0, 0, 0, 0)',
  deepNavy: '#11314d',
  lightNavy: '#25598b',
  mediumNavy: '#183d61',
} as const

export const color = {
  bc: basicColor,
  ec: extendedColor,
}

export const spacing = {
  xxxxl: 28,
  xxxl: 24,
  xxl: 22,
  xl: 20,
  lg: 18,
  md: 16,
  sm: 14,
  xs: 12,
  xxs: 10,
  xxxs: 8,
  xxxxs: 6,
} as const

export const fontSize = {
  xl: '2.0rem',
  lg: '1.8rem',
  md: '1.6rem',
  sm: '1.4rem',
  xs: '1.2rem',
} as const

export const rounded = {
  default: '4px',
  circle: '5000px',
} as const

export const opacity = {
  opacity: {
    low: { code: '1A', number: 0.1 },
    medium: { code: '66', number: 0.4 },
    high: { code: '99', number: 0.6 },
  },
} as const

export const shadow = {
  sm: '0 2px 4px rgba(0, 0, 0, 0.1)',
  md: '0 4px 6px rgba(0, 0, 0, 0.1)',
  lg: '0 6px 12px rgba(0, 0, 0, 0.15)',
} as const

export const zIndex = {
  backGroundLayout: 1,
} as const
export const theme = {
  c: color,
  s: spacing,
  fs: fontSize,
  rd: rounded,
  op: opacity,
  sd: shadow,
  zi: zIndex,
} as const

declare module '@emotion/react' {
  export interface Theme {
    c: typeof color
    s: typeof spacing
    fs: typeof fontSize
    rd: typeof rounded
    op: typeof opacity
    sd: typeof shadow
    zi: typeof zIndex
  }
}
export type ThemeType = typeof theme
